// @flow

import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { getARMNavigationDetails, getCommonNavigationDetails, getPRMNavigationDetails } from './constants';
import { hideOffersTabForDemoAccount } from '../../common/utils';

import { PRM_PRIVILEGE } from './../../common/constants';

import LogoIcon from '../../images/logo.png';
import LogoNameIcon from '../../images/logo-name.png';

import '../../stylesheets/fontcustom.css';
import './SideNav.scss';

type Props = {
  user: any,
}

type State = {
  isNavbarExpanded: boolean,
}

class SideNav extends React.PureComponent<Props, State> {

  state = {
    isNavbarExpanded : false,
  }

  handleHoverEnter = () => {
    this.setNavbarState(true);
  }

  handleHoverLeave = () => {
    this.setNavbarState(false);
  }

  setNavbarState = (value) => {
    this.setState({
      isNavbarExpanded: value
    });
  }

  render () {
    const { isNavbarExpanded } = this.state;
    const { user } = this.props;
    const WIDTH = isNavbarExpanded ? '204px' : '76px';
    return (
      <nav
        id="sidebar"
        style={{width: WIDTH}}
        onMouseEnter={this.handleHoverEnter}
        onMouseLeave={this.handleHoverLeave}
      >
        <NavLink to={user && user.privilege === PRM_PRIVILEGE ? '/offers' : '/dashboard'}>
          <div className="sidebar-header">
            <img
              alt="logoicon"
              src={LogoIcon}
              className="sidebar-logo"
            />
            {isNavbarExpanded && (<img
              alt="logonameicon"
              src={LogoNameIcon}
              className="sidebar-logo-name"
            />)}
          </div>
        </NavLink>

        {
          user && user.privilege === PRM_PRIVILEGE ? (
            <ul className="list-unstyled components">
              {
                getPRMNavigationDetails().map((item, index) => {
                  return (
                    <li key={item+index} className={item.className}>
                      <NavLink to={item.linkTo} exact activeClassName='active'>
                        <div className="list-item">
                          <span className="list-item-icon">
                            <span className={item.iconClassName}></span>
                          </span>
                          {isNavbarExpanded && (<span className="list-item-text">{item.name}</span>)}
                        </div>
                      </NavLink>
                    </li>
                  );
                })
              }
            </ul>
          ) : (
            <ul className="list-unstyled components">
              {
                getARMNavigationDetails()
                  .filter(hideOffersTabForDemoAccount)
                  .map((item, index) => {
                    return (
                      item.display &&
                        <li key={item+index} className={item.className}>
                          <NavLink to={item.linkTo} exact activeClassName='active'>
                            <div className="list-item">
                              <span className="list-item-icon">
                                <span className={item.iconClassName}></span>
                              </span>
                              {isNavbarExpanded && (<span className="list-item-text">{item.name}</span>)}
                            </div>
                          </NavLink>
                        </li>
                    );
                  })
              }
            </ul>
          )
        }

        <ul className="list-unstyled components bottom-nav-items">
          {
            getCommonNavigationDetails().map((item, index) => {
              return (
                <li key={item+index} className={item.className}>
                  <NavLink to={item.linkTo}>
                    <div className="list-item">
                      <span className="list-item-icon">
                        <span className={item.iconClassName}></span>
                      </span>
                      {isNavbarExpanded && (<span className="list-item-text">{item.name}</span>)}
                    </div>
                  </NavLink>
                </li>
              );
            })
          }
        </ul>
      </nav>
    );
  }
}

//  REDUX CONNECTION
///////////////////////////////////////////////////////////////////////
function mapStateToProps(state) {
  const { login } = state;
  const loginToJS = login.toJS();
  const { user } = loginToJS;

  return {
    user: user,
  };
}

export default connect(mapStateToProps, null)(SideNav);
